export default "__VITE_ASSET__DVmstLVh__"